import CiscoLogo from '@/assets/images/cisco.svg';

const CiscoIcon = ({ size = 25 }) => (
    <img
        src={CiscoLogo}
        alt="Cisco Logo"
        style={{ height: size, width: size }}
    />
);

export default CiscoIcon;
